import {useEffect, useState} from 'react'
import magicVoice from "../assets/icons/magic_voice.png"
import mtn from "../assets/icons/mtn.png"
import { useMainContext } from '../callContext/MainContext'
import { SubscriptionResponseText as text } from '../database/SubscriptionText'
import { HeadersText as header } from '../database/Text'
const Subsription = ({children}) => {
    const {language}=useMainContext();
    const modalType=localStorage.getItem("modalType")?localStorage.getItem("modalType"):"";
    const [modalText,setModalText]=useState({
      msg1:"",
      msg2:"",
      msg3:""
    })
    useEffect(()=>
    {
        const m1=localStorage.getItem("msg1");  
        const m2=localStorage.getItem("msg2");  
        const m3=localStorage.getItem("msg3");  
        setModalText(
          {
            msg1:m1,
            msg2:m2,
            msg3:m3
          }
        )
    },[]);

  return (
    <div className='min-h-screen yellow-theme-color py-4 text-xl text-center flex flex-col justify-around'>
        <div>
          <img src={magicVoice} alt="magic voice" className='m-auto w-28' height="100px"/>
        <h1 className='font-bold tracking-wider text-xl text-red-500 text-center mt-2'>{header.magicVoiceText[language]}</h1>
        </div>
        {children}
        <div>
          {modalType!=='pending' &&
          <>
        <p className='px-10 pb-2' >{text?.orText?.[language]}</p>
        {(modalType!=='grace') ?  <>
        <p className='px-10 py-2' >{text?.dialText?.[language]} {" "}<span className='text-lg font-extrabold'> 
        {text?.shortCodeText?.[language]}
        </span> {text?.dialMsgText?.[language]}</p>
          </>:<>
        <p className='px-10 py-2' >{text?.rechargeAgainText?.[language]} {" "}<span className='text-lg font-extrabold'> 
        {text?.shortCodeText?.[language]}</span></p>
          </>
          }
          </>
          }
        <img src={mtn} alt="magic voice" className='m-auto w-28 mt-4 h-24 border-[1px] border-white' height="100px"/>
        </div>
    </div>
  )
}

export default Subsription